var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"sticky-footer bg-white",attrs:{"id":"footer"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"copyright text-center"},[_c('span',[_c('router-link',{attrs:{"to":'/imprint'}},[_c('span',[_vm._v("Impressum")])])],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }